import countries from './countries';

const byCode = Object.fromEntries(countries.map((country) => [country.code, country]));

export const getCountryByCode = (code) => {
  if (!code) return null;
  return byCode[String(code).toLowerCase()] || null;
};

export const STATEMENTS = [
  { id: 'nairobi', text: 'This country’s capital is Nairobi.', code: 'ke' },
  { id: 'largest-sa', text: 'Largest country in South America.', code: 'br' },
  { id: 'eiffel', text: 'Home of the Eiffel Tower.', code: 'fr' },
  { id: 'canberra', text: 'This country’s capital is Canberra.', code: 'au' },
  { id: 'great-wall', text: 'The Great Wall was built in this country.', code: 'cn' },
  { id: 'largest-world', text: 'Largest country in the world by land area.', code: 'ru' },
  { id: 'tokyo', text: 'This country’s capital is Tokyo.', code: 'jp' },
  { id: 'statue-liberty', text: 'Home of the Statue of Liberty.', code: 'us' },
  { id: 'nigeria-pop', text: 'Most populous country in Africa.', code: 'ng' },
  { id: 'cairo', text: 'This country’s capital is Cairo.', code: 'eg' },
  { id: 'algeria-area', text: 'Largest country in Africa by area.', code: 'dz' },
  { id: 'ottawa', text: 'This country’s capital is Ottawa.', code: 'ca' },
  { id: 'machu', text: 'Home of Machu Picchu.', code: 'pe' },
  { id: 'new-delhi', text: 'This country’s capital is New Delhi.', code: 'in' },
  { id: 'colosseum', text: 'The Colosseum is in this country.', code: 'it' },
  { id: 'berlin', text: 'This country’s capital is Berlin.', code: 'de' },
  { id: 'chile-coast', text: 'Long, thin country along South America’s Pacific coast.', code: 'cl' },
  { id: 'madrid', text: 'This country’s capital is Madrid.', code: 'es' },
  { id: 'cape-town', text: 'Home of Table Mountain and Cape Town.', code: 'za' },
  { id: 'mexico-city', text: 'This country’s capital is Mexico City.', code: 'mx' },
  { id: 'nz-island', text: 'Island nation southeast of Australia.', code: 'nz' },
  { id: 'seoul', text: 'This country’s capital is Seoul.', code: 'kr' },
  { id: 'stockholm', text: 'This country’s capital is Stockholm.', code: 'se' },
  { id: 'warsaw', text: 'This country’s capital is Warsaw.', code: 'pl' },
  { id: 'acropolis', text: 'Home of the Acropolis.', code: 'gr' },
  { id: 'bangkok', text: 'This country’s capital is Bangkok.', code: 'th' },
  { id: 'arabian', text: 'Largest country on the Arabian Peninsula.', code: 'sa' },
  { id: 'buenos-aires', text: 'This country’s capital is Buenos Aires.', code: 'ar' },
  { id: 'ankara', text: 'This country’s capital is Ankara.', code: 'tr' },
  { id: 'lisbon', text: 'This country’s capital is Lisbon.', code: 'pt' },
  { id: 'ulaanbaatar', text: 'This country’s capital is Ulaanbaatar.', code: 'mn' },
  { id: 'landlocked', text: 'Largest landlocked country in the world.', code: 'kz' },
  { id: 'dublin', text: 'This country’s capital is Dublin.', code: 'ie' },
  { id: 'iceland', text: 'Nordic island country just south of the Arctic Circle.', code: 'is' },
  { id: 'islamabad', text: 'This country’s capital is Islamabad.', code: 'pk' },
  { id: 'indonesia', text: 'World’s largest archipelago nation in Southeast Asia.', code: 'id' },
  { id: 'kyiv', text: 'This country’s capital is Kyiv.', code: 'ua' },
  { id: 'amsterdam', text: 'This country’s capital is Amsterdam.', code: 'nl' },
];

const shuffle = (items) => {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
};

export const createStatementDeck = (excludeId = null) => {
  const pool = excludeId
    ? STATEMENTS.filter((statement) => statement.id !== excludeId)
    : STATEMENTS;
  return shuffle(pool);
};

export const pickStatement = (excludeId = null) => {
  const deck = createStatementDeck(excludeId);
  return deck[0] || STATEMENTS[0];
};
